//查询挂单列表
import request from "@/utils/request";

//新增买入挂单
export function addBuyOrder(data) {
    return request({
        url: '/system/pendingOrder/addPendingOrderByBuyer',
        method: 'post',
        data
    })
}

//新增买入挂单列表
export function getBuyOrderList(data) {
    return request({
        url: '/system/pendingOrder/list',
        method: 'get',
        params: data
    })
}

//获取买入挂单详情
export function getBuyOrderDetail(data) {
    return request({
        url: '/system/pendingOrder/' + data,
        method: 'get'
    })
}

//修改买入挂单
export function editBuyOrder(data) {
    return request({
        url: '/system/pendingOrder/updatePendingOrder',
        method: 'post',
        data
    })
}

//新增卖出入挂单
export function addShell(data) {
    return request({
        url: '/web/orders/tradeForm',
        method: 'post',
        data: data
    })
}


//查询卖出列表
export function getShellList(data) {
    let obj = {
        ...data,
        reserve2: 3
    }
    return request({
        url: '/web/orders/list',
        method: 'get',
        params: obj
    })
}

//修改卖出订单
export function editShellDetail(data) {
    return request({
        url: '/web/orders/updateOrder',
        method: 'post',
        data: data
    })
}


//验证支付
export function codePay(data) {
    return request({
        url: '/web/orders/confirmOrder',
        method: 'post',
        data: data
    })
}


// /*
// *
// * @param {Object} data
// * @param {number} data.type - 请求类型，0 表示 USDE，1 表示 GHS
// * */
export function getMarketReturn(data) {
    return request({
        url: '/system/pendingOrder/marketTrade',
        method: 'get',
        params: data
    })
}

